import { merchantInstance, backendVersion, globalAxios } from "@/axios-path.js";

export default {
    namespaced: true,
    state: {
        merchantNotificationList: [],
        merchantBannersList: [],
        weserveADSList: [],
    },
    mutations: {
        setMerchantNotificationList(state, data) {
            state.merchantNotificationList = data
        },
        deleteMerchantNotification(state, notification_id) {
            let index = state.merchantNotificationList.findIndex(val => val.notification_id == notification_id)
            state.merchantNotificationList.splice(index, 1)
        },
        setMerchantBannerList(state, list) {
            state.merchantBannersList = list
        },
        DELETE_BANNERS_MERCHANT(state, bannerId) {
            let index = state.merchantBannersList.findIndex(val => val.banner_merchant_id == bannerId);
            state.merchantBannersList.splice(index, 1)
        },
        setWeserveADSList(state, list) {
            state.weserveADSList = list;
        },
        addWeserveADS(state, item) {
            state.weserveADSList.push(item)
        },
        editWeserveADS(state, item) {
            let index = state.weserveADSList.findIndex(val => val.ads_id == item.ads_id)
            state.weserveADSList.splice(index, 1, item)
        },
        deleteWeserveADS(state, ads_id) {
            let index = state.weserveADSList.findIndex(val => val.ads_id == ads_id)
            state.weserveADSList.splice(index, 1)
        }
    },
    actions: {
        async deleteMerchantNotification({ dispatch, commit }, notification_id) {
            let url = backendVersion.version + "/merChant/deleteNotification/" + notification_id;
            let res = await dispatch("fetchGeneral/merchantDeleteData", url, {
                root: true
            });
            if (typeof res == "boolean" && res == false) {
            } else {
                commit("deleteMerchantNotification", notification_id);
            }
        },
        async getMerchantNotification({ dispatch, commit }) {
            let url = backendVersion.version + "/merChant/notification";
            let res = await dispatch("fetchGeneral/merchantGetData", url, {
                root: true,
            });
            if (typeof res == "boolean" && res == false) {
                return 0;
            } else {
                commit("setMerchantNotificationList", res);
                return res;
            }
        },
        async sendMerchantNotification({ commit, dispatch }, form) {
            let url = backendVersion.version + "/merChant/notification";
            let res = await dispatch(
                "fetchGeneral/merchantPostData",
                { url, form },
                { root: true }
            );
            if (typeof res == "boolean" && res == false) {
                return false;
            } else {
                return true;
            }
        },
        async FETCH_BANNERS_MERCHANT({ commit }, config) {
            let url = backendVersion.version + "/merChant/bof_get_all_banner_merchant";

            //  status=3&date_start_end=2021-05-18,2021-06-18
            return merchantInstance
                .get(url, { params: config })
                .then(res => {
                    commit("setMerchantBannerList", res.data);
                    return res;
                })
                .catch(err => {
                    return false;
                });
        },
        async CREATE_BANNERS_MERCHANT({ commit }, payload) {
            let url = backendVersion.version + "/merChant/bof_create_banner_merchant";
            return merchantInstance
                .post(url, payload)
                .then(res => {
                    return res.data;
                })
                .catch(err => {
                    return false;
                });
        },
        async UPDATE_BANNERS_MERCHANT({ commit }, payload) {
            let url = backendVersion.version + "/merChant/bof_update_banner_merchant";
            return merchantInstance
                .put(url, payload)
                .then(res => {
                    return res.data;
                })
                .catch(err => {
                    return false;
                });
        },
        async DELETE_BANNERS_MERCHANT({ commit }, bannerId) {
            let url = backendVersion.version + "/merChant/bof_delete_banner_metchant";
            return merchantInstance
                .delete(url, {
                    params: {
                        id: bannerId
                    }
                })
                .then(res => {
                    commit('DELETE_BANNERS_MERCHANT', bannerId)
                    return true;
                })
                .catch(err => {
                    return false;
                });
        },
        async fetchWeserveADSList({ commit }) {
            let url = `/api/v1/management/ads`;
            return globalAxios
                .get(url)
                .then((res) => {
                    console.log(res);
                    if (res.msg === false) return false;
                    commit('setWeserveADSList', res.data)
                    return res.data;
                })
                .catch((error) => false);
        },
        async createWeserveADS({ commit }, payload) {
            let url = `/api/v1/management/ads`;
            let body = {
                "ads_action_name_th": payload.ads_action_name_th,
                "ads_action_name_en": payload.ads_action_name_en,
                "ads_action_type": payload.ads_action_type,
                "ads_store_id": payload.ads_store_id,
                "ads_hyper_link": payload.ads_hyper_link,
                "ads_title_th": payload.ads_title_th,
                "ads_title_en": payload.ads_title_en,
                "ads_description_th": payload.ads_description_th,
                "ads_description_en": payload.ads_description_en,
                "ads_image": payload.ads_image,
                "ads_district": payload.ads_district,
                "ads_province": payload.ads_province,
                "ads_support_by": payload.ads_support_by
            };

            return globalAxios
                .post(url, body)
                .then((res) => {
                    console.log(res);
                    if (res.msg === false) return false;
                    commit('addWeserveADS', res.data)
                    return res.data;
                })
                .catch((error) => false);
        },
        async updateWeserveADS({ commit }, payload) {
            let url = `/api/v1/management/ads`;
            let body = {
                "ads_id": payload.ads_id,
                "ads_action_name_th": payload.ads_action_name_th,
                "ads_action_name_en": payload.ads_action_name_en,
                "ads_action_type": payload.ads_action_type,
                "ads_store_id": payload.ads_store_id,
                "ads_hyper_link": payload.ads_hyper_link,
                "ads_title_th": payload.ads_title_th,
                "ads_title_en": payload.ads_title_en,
                "ads_description_th": payload.ads_description_th,
                "ads_description_en": payload.ads_description_en,
                "ads_image": payload.ads_image,
                "ads_district": payload.ads_district,
                "ads_province": payload.ads_province,
                "ads_support_by": payload.ads_support_by,
                "ads_status": payload.ads_status,
            };

            return globalAxios
                .put(url, body)
                .then((res) => {
                    console.log(res);
                    if (res.msg === false) return false;
                    commit('editWeserveADS', res.data)
                    return res.data;
                })
                .catch((error) => false);
        },
        async removeWeserveADS({ commit }, ads_id) {
            let url = `/api/v1/management/ads?ads_id=${ads_id}`;
            return globalAxios
                .delete(url)
                .then((res) => {
                    console.log(res);
                    if (res.msg === false) return false;
                    commit('deleteWeserveADS', ads_id)
                    return true;
                })
                .catch((error) => false);
        },
    },
    getters: {}
};
